import message from 'antd/lib/message'
import { MessageInstance } from 'antd/lib/message/interface'
import React, { createContext } from 'react'

export const MessageContext = createContext<[MessageInstance] | null>(null)

export const MessageProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    const [messageApi, contextHolder] = message.useMessage()

    return (
        <MessageContext.Provider value={[messageApi]}>
            {contextHolder}
            {children}
        </MessageContext.Provider>
    )
}
